import React, { Component } from 'react'

class Footer extends Component {
  render () {
    return (
      <div>
        {' '}
        <footer className='container-fluid text-center'>
          <p>Developed by Adarsh</p>
        </footer>
      </div>
    )
  }
}

export default Footer
